import React from 'react';
import type { LineProps } from 'Components/frameworks/line/Line';
import 'Components/frameworks/line/Line';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { getBaiduStructuredPageData } from 'Src/seo/json-ld';
import { isBaiduBot } from 'Src/seo/sitemap/sitemap.utils';
import { isChineseLocale } from 'Utils/locale/localeUtils';
import { queryParamToString } from 'Src/types/server-helpers';
type Props = {
  lines: ReadonlyArray<LineProps>;
  locale?: string;
  userAgent?: string | void;
  originalUrl: string;
  pageTitle: string;
  pageDescription: string;
};
export const BaiduSeoScript = ({
  lines,
  locale,
  userAgent,
  originalUrl,
  pageTitle,
  pageDescription,
}: Props) => {
  const { isDesktop } = useResponsive();

  const getImmersives = (allLines) => {
    let immersives = [];

    const collectFn = (line) => {
      const backgroundURL = isDesktop
        ? line.props.backgroundURLDesktop
        : line.props.backgroundURLMobile;
      immersives = line.name === 'immersive' ? [...immersives, backgroundURL] : immersives;
      immersives =
        line.name === 'product-immersive' && !!line.props.media?.photos
          ? [...immersives, ...line.props.media.photos.map((p) => p.url)]
          : immersives;
      (line.props.lines || []).forEach(collectFn);
    };

    allLines.forEach(collectFn);
    return immersives;
  };

  return (
    isBaiduBot(queryParamToString(userAgent) ?? '') &&
    isChineseLocale(locale) && (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            getBaiduStructuredPageData(
              pageTitle,
              pageDescription,
              getImmersives(lines),
              originalUrl,
            ),
          ),
        }}
      />
    )
  );
};
